import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBgFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1339_53057)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M-0.000976562 30.46H49.9989V40.5174C49.9989 40.9934 49.6129 41.3795 49.1368 41.3795H0.861131C0.385058 41.3795 -0.000976562 40.9934 -0.000976562 40.5174V30.46Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M0.861131 8.62061H49.1369C49.613 8.62061 49.999 9.00664 49.999 9.48271V19.5401H-0.000976562V9.48271C-0.000976562 9.00664 0.385058 8.62061 0.861131 8.62061Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.9989 19.54H-0.000976562V30.459H49.9989V19.54Z",
					fill: "#73AF00"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1339_53057",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 50,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgBgFlag);
export { ForwardRef as ReactComponent };
